// images
import craterPng from './images/crater.png';
import explosionGif from './images/explosion.gif';
import happyCatGif from './images/happy-cat.gif';
import officeHandshakeMeme from './images/office-handshake-meme.png';
import sadHamsterGif from './images/sad-hamster.gif';
import notFound404 from './images/404_error.png';
import catSadgeLoadingGif from './images/sadge_cat_loading.gif';

// sound effects
import capture from './sounds/capture.mp3';
import castle from './sounds/castle.mp3';
import gameEnd from './sounds/game-end.mp3';
import gameStart from './sounds/game-start.mp3';
import illegal from './sounds/illegal.mp3';
import moveCheck from './sounds/move-check.mp3';
import moveOpponent from './sounds/move-opponent.mp3';
import moveSelf from './sounds/move-self.mp3';
import ohNoBoom from './sounds/oh-no-boom.mov';
import premove from './sounds/premove.mp3';
import promote from './sounds/promote.mp3';
import shovel from './sounds/shovel_sound.mov';
import tenSeconds from './sounds/tenseconds.mp3';
import iwcPop from './sounds/iwc_pop.mp3';
import iwcSwish from './sounds/iwc_swish.wav';

// pieces
import wK from './pieces/wK.svg';
import wQ from './pieces/wQ.svg';
import wR from './pieces/wR.svg';
import wB from './pieces/wB.svg';
import wN from './pieces/wN.svg';
import wP from './pieces/wP.svg';
import bK from './pieces/bK.svg';
import bQ from './pieces/bQ.svg';
import bR from './pieces/bR.svg';
import bB from './pieces/bB.svg';
import bN from './pieces/bN.svg';
import bP from './pieces/bP.svg';

export const images = {
    craterPng,
    explosionGif,
    happyCatGif,
    officeHandshakeMeme,
    sadHamsterGif,
    catSadgeLoadingGif,
    notFound404
};

export const sounds = {
    capture,
    castle,
    gameEnd,
    gameStart,
    illegal,
    moveCheck,
    moveOpponent,
    moveSelf,
    ohNoBoom,
    premove,
    promote,
    shovel,
    tenSeconds,
    iwcPop,
    iwcSwish
};

export const pieces = {
    wK,
    wQ,
    wR,
    wB,
    wN,
    wP,
    bK,
    bQ,
    bR,
    bB,
    bN,
    bP
};